import React, { JSX, useState } from 'react';
import Styles from './FalconMessage.module.scss';
import { Asset, ComponentWithContentProps, GenericSBProps } from '../types';
import { FalconMessageTypes } from '../../utils/data-source';
import { iconHandler } from '../../utils/utils';
import { getStaticAssetPath } from '../../utils/global';
import RichText from '../richtext';

export interface SuccessMessageSchema extends GenericSBProps {
  text: string;
  description: any;
  icon?: Asset;
  chooseMessageType: FalconMessageTypes;
  closeIcon?: boolean;
}

const FalconMessage = ({
  content,
  metadata
}: ComponentWithContentProps<SuccessMessageSchema>): JSX.Element => {
  const [close, setClose] = useState(false);

  const onCloseButtonHandler = () => {
    setClose(!close);
  };

  return (
    <div>
      {content?.chooseMessageType && !close && (
          <div className={`${Styles[content.chooseMessageType]}`}>
            <img
              alt='icons'
              height={32}
              width={32}
              src={getStaticAssetPath(iconHandler(content.chooseMessageType))}
            />

            {(content.text || content.description) && (
              <div className={Styles['text']}>
                {content.text && <h4 className={Styles['title']}>{content.text}</h4>}
                {content.description && (
                  <div className={Styles['description']}>
                    <RichText content={content.description} />
                  </div>
                )}
              </div>
            )}
            {content.closeIcon && (
              <div onClick={onCloseButtonHandler} className={Styles['closeIcon']}>
                <img
                  src={getStaticAssetPath('/icons/close-icon.svg')}
                  alt={'close icon'}
                  height={14}
                  width={14}
                />
              </div>
            )}
          </div>
      )}
    </div>
  );
};

export default FalconMessage;
